export default "__VITE_ASSET__0zAeffaj__"